import { render, staticRenderFns } from "./Calibration.vue?vue&type=template&id=5b10bae0"
import script from "./Calibration.vue?vue&type=script&lang=js"
export * from "./Calibration.vue?vue&type=script&lang=js"
import style0 from "./Calibration.vue?vue&type=style&index=0&id=5b10bae0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports